import styled from '@emotion/styled';
import {motion} from 'framer-motion';
import spinIcon from "../../../common/emotion/images/loader.svg";

const Container = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;    
    display: flex;
    justify-content: center;
    align-items: center;
`

const Loader = styled.div`
    animation: rotate_image 3s linear infinite;
    transform-origin: 50% 50%;
    width: 30%;
    height: 30%;
    max-width: 50px; /* 적절한 크기 지정 */
    max-height: 50px; /* 적절한 크기 지정 */
    background-image: url(${spinIcon});
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;

    @keyframes rotate_image {
        100% {
            transform: rotate(360deg);
        }
    }
`;

export default function Spinner() {
    return (
        <Container>
            <Loader/>
        </Container>
    );
}